/* RESPONSIBLE TEAM: team-standalone */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import { get } from '@ember/object';
import type Model from '@ember-data/model';
import type AppService from 'embercom/services/app-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import type Store from '@ember-data/store';
import StandardizedPlatform from 'embercom/objects/standalone/platforms/standardized-platform';

export default class FieldAvailableInProduction extends BaseValidator {
  @service declare appService: AppService;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;
  @service declare store: Store;

  validate(
    _value: unknown,
    options: { messageKey: string; attributeIdentifierPath: string },
    model: Model,
  ) {
    let identifier = get(model, options.attributeIdentifierPath) as string | undefined;
    if (!identifier) {
      return true;
    }

    if (!this.appService.app.canUseStandaloneMultiEnv) {
      return true;
    }

    let platform = this.finStandaloneService.platform;
    if (!platform || !(platform instanceof StandardizedPlatform)) {
      return true;
    }

    if (platform.isLoadingDataFields) {
      return true;
    }

    // Extract descriptor ID from format: conversation.custom_attribute.{id}
    let parts = identifier.split('.');
    let descriptorId = parts[2];
    if (!descriptorId) {
      return true;
    }

    let descriptor = this.store.peekRecord('conversation-attributes/descriptor', descriptorId);
    if (!descriptor) {
      return true;
    }

    if (!descriptor.isStandaloneSyncedAttribute) {
      return true;
    }

    if (descriptor.archived) {
      return true;
    }

    if (!platform.isMappedConversationAttribute(identifier)) {
      return this.intl.t(options.messageKey);
    }

    return true;
  }

  static getDependentsFor() {
    return [];
  }
}
